import React from 'react'
import PropTypes from 'prop-types'

import { Picture } from '@aok/image'
import Icon from '@aok/icon-linear'

import { ImageShape, ImageType } from '../M047Constants'

const M047ImagePerQuestion = ({ imageType, imageShape, image, icon }) => {
  if (imageType === ImageType.Picture && image) {
    return (
      <Picture
        className="w-full h-full"
        {...image}
        imgClassName={` ${imageShape === ImageShape.Circle ? 'w-160 h-160 rounded-full' : 'w-full h-auto'}`}
      />
    )
  } else if (imageType === ImageType.Icon && icon) {
    return (
      <div className="mx-auto w-160 h-160 bg-ffffff rounded-full flex justify-center items-center">
        <Icon name={icon} className="fill-current text-005e3f w-80 h-80" />
      </div>
    )
  }

  return null
}

M047ImagePerQuestion.propTypes = {
  imageType: PropTypes.oneOf(Object.values(ImageType)),
  imageShape: PropTypes.oneOf(Object.values(ImageShape)),
  image: PropTypes.shape({
    alt: PropTypes.string,
    copyright: PropTypes.string,
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        breakpoint: PropTypes.number,
      })
    ),
  }),
  icon: PropTypes.string,
}

export default M047ImagePerQuestion
